// Route: /recordings/new — старт новой записи лекции.
//
// Live UI вынесен в RecordingLiveScreen (общий с /recordings/$id при активной
// записи). После create session URL сразу становится /recordings/$id.

import { createFileRoute, Navigate } from "@tanstack/react-router";
import { RecordingLiveScreen } from "@/components/recordings/recording-live-screen";
import { useRecorderStore } from "@/stores/recorder";

export const Route = createFileRoute("/recordings/new")({
	component: RecordingNewPage,
});

const LIVE_STATUSES = new Set(["recording", "paused", "starting", "stopping"]);

function RecordingNewPage(): React.ReactElement {
	const recordingId = useRecorderStore((s) => s.recordingId);
	const status = useRecorderStore((s) => s.status);

	// Уже идёт запись — сразу на URL с id (reload → detail/stalled, не new).
	if (recordingId && LIVE_STATUSES.has(status)) {
		return <Navigate to="/recordings/$id" params={{ id: recordingId }} replace />;
	}

	return <RecordingLiveScreen />;
}
